/**
 * Created by lu on 2017/9/11.
 */
var nb = require('../../nb');
var dialog = require('./Dialog');
var searchBox = require('../form/SearchBox');
var loginMenu = require('./LoginMenu');
var accountMenu = require('./AccountMenu').accountMenu;
var wishMenu = require('./WishMenu').wishMenu;
var shopCartMenu = require('./ShopCartMenu').ShopCartMenu;
module.exports = nb.define({
    view: {
        id: 'page-header',
        'class': ['header', nb.bind('status')],
        $html: [{
            'class': 'navbar-collapse collapse',
            'role': "navigation",
            $html: [{
                'class': ['nav navbar-nav ultra-menu-secondary', nb.bind('isLogin')],
                $html: [{
                    'class': 'menu-right',
                    tag: 'ul',
                    $html: [{
                        'class': 'user-login-wrapper',
                        tag: 'li',
                        $html: [{
                            $name: 'login',
                            tag: 'a',
                            href: 'login.html',
                            $text: '用户登录'
                        }, {
                            $name: 'loginMenu',
                            $type: loginMenu,
                            $model: 'loginMenu'

                        }]
                    }, {
                        'class': 'user-account',
                        tag: 'li',
                        $html: [{
                            $name: 'account',
                            tag: 'a',
                            href: 'home.html',
                            $text: nb.bind('accountName')
                        }, {
                            $name: 'accountMenu',
                            $type: accountMenu,
                            $model: 'accountMenu'

                        }]
                    }, {
                        'class': 'line',
                        tag: 'li'
                    }, {
                        'class': 'wish-list-wrapper',
                        tag: 'li',
                        $html: [{
                            $name: 'wish',
                            tag: 'a',
                            href: 'wish.html',
                            $text: '心愿清单'
                        }, {
                            $name: 'wishMenu',
                            $type: wishMenu,
                            $model: "wishMenu"
                        }]
                    }, {
                        'class': 'line',
                        tag: 'li'
                    }, {
                        'class': 'shop-cart-wrapper',
                        tag: 'li',
                        $html: [{
                            $name: 'shopCart',
                            'class': 'shopCart',
                            tag: 'a',
                            href: 'shopCart.html',
                            $html: [{
                                tag: "i",
                                'class': 'iconfont icon-cart'
                            }, {
                                tag: "span",
                                $text: '购物车',
                                style: {
                                    'padding-left': '2px'
                                }
                            }, {
                                tag: "span",
                                $text: nb.bind('shopCartCount') //  shopCartCount
                            }]
                        }, {
                            $name: 'shopCartMenu',
                            $type: shopCartMenu,
                            $model: 'shopCartMenu'
                        }]
                    }]
                }
                ]
            }, {
                $name: 'ultraMenuMain',
                'class': ['ultra-menu-main', nb.bind('activeLi')],
                tag: 'ul',
                $html: [{
                    tag: 'li',
                    'class': "index",
                    $html: {
                        tag: 'a',
                        $text: '首页',
                        href: 'index.html'
                    }
                }, {
                    tag: 'li',
                    'class': "storyList",
                    $html: {
                        tag: 'a',
                        $text: '西区故事',
                        target: '_blank',
                        href: 'storyList.html'
                    }
                }, {
                    tag: 'li',
                    'class': "series",
                    $html: [{
                        tag: 'a',
                        href: 'seriesList.html',
                        target: '_blank',
                        $text: '生活方式'
                    }, {

                        'class': 'series-list',
                        $html: [{
                            'class':'header-swiper-box',
                            $html:[{
                                'class': 'swiper-container header-series-swiper',
                                $html: {
                                    'class': 'swiper-wrapper',
                                    $type: nb.view.List,
                                    $model: 'seriesList'
                                }
                            }, {
                                'class': 'swiper-button-prev'
                            }, {
                                'class': 'swiper-button-next'
                            }]
                        }]
                    }]
                }, {
                    tag: 'li',
                    'class': "products",
                    $html: [{
                        tag: 'a',
                        $text: '在线挑选',
                        target: '_blank',
                        href: 'products.html'
                    }, {
                        tag: 'ul',
                        'class': 'class-list',
                        $type: nb.view.List,
                        $model: 'classList'
                    }]
                }, {
                    tag: 'li',
                    'class': "business",
                    $html: [{
                        tag: 'a',
                        $text: '加盟合作',
                        target: '_blank',
                        href: 'about.html'
                        // }, {
                        //     tag: 'ul',
                        //     'class': 'business-list',
                        //     $type: nb.view.List,
                        //     $model: 'businessList'
                    }]
                }, {
                    tag: 'li',
                    'class': 'search-li',
                    $html: [{
                        tag: 'a',
                        $name: 'search-li',
                        $html: [{
                            tag: 'span',
                            $text: '搜索'
                        }, {
                            $name: 'icon-search',
                            tag: 'i',
                            'class': 'iconfont icon-search',
                            style: {
                                'font-size': '14px',
                                'font-weight': 'bold'
                            }
                        }]
                    }, {
                        $name: 'searchBox',   //搜索
                        $type: searchBox,
                        $model: 'searchBox'
                    }]
                }]
            }]
        }, {
            'class': 'navbar-header',
            $html: [{
                'data-toggle': "collapse",
                'data-target': "#header-dialog",
                $name: 'mobileBtn',
                'class': 'mobile-btn',
                $html: [{
                    tag: 'span',
                    'class': 'iconfont icon-caidan'
                }, {
                    tag: 'span',
                    'class': '',
                    $text: '菜单',
                    style: {
                        'font-size': '14px'
                    }
                }]
            }, {
                $name: 'logo',
                'class': 'logo',
                tag: 'img',
                src: './image/logo/logo.svg'
            }, {
                'class': 'right-wrapper',
                tag: 'ul',
                $html: [{
                    'class': 'shop-cart',
                    tag: 'li',
                    $html: {
                        tag: 'a',
                        href: 'shopCart.html',
                        $html: [{
                            tag: "i",
                            'class': 'iconfont icon-cart'
                        }, {
                            tag: "span",
                            $text: '购物车',
                            style: {
                                'font-size': '14px '
                            }
                        }, {
                            tag: "span",
                            $text: nb.bind('shopCartCount') //  shopCartCount
                        }]
                    }
                }, {
                    'class': 'search',
                    tag: 'li',
                    $html: [{
                        $name: 'search',
                        tag: 'i',
                        'class': 'iconfont icon-search'
                    }, {
                        $name: 'm-search-box',
                        'class': 'search-box',
                        $type: searchBox,
                        $model: 'searchBox'
                    }, {
                        $name: 'search-mask',
                        'class': 'search-mask'
                    }]
                }]
            }]
        }, {
            'class': 'mobile-menu-dialog',
            $name: 'mobileMenu',
            $type: dialog,
            $model: 'dialog'
        }]
    },
    method: {
        init: function () {
            var self = this;
            this._flag = true;
            this.$('ultraMenuMain').on('click', 'a', function () {
                var href = $(this).attr('href');
                var text = $(this).text();
                if (href) {
                    _hmt.push(['_trackEvent', '导航', 'click', text])
                }
            });
            this.$('search-li').on('click', function () {
                self.$('searchBox').$().toggleClass('active');
            });
            // this.$('search-li').on('mouseover',function () {
            //     self.$('searchBox').$().addClass('active');
            // });
            this.$('ultraMenuMain').on('mouseover', '>li:not(.search-li)', function () {
                self.$('searchBox').$().removeClass('active');
            });
            nb.model.onChange(nb.opts.clientReady, function (inEvent) {
                $(document.body).on('click', function (inEvent) {
                    var model = self.getModel().get('searchBox');
                    model.set('searchBoxStatus', '');
                    inEvent.stopImmediatePropagation();
                });
            }, this);
            this.$('search').on('click', function () {
                $(this).parent().toggleClass('active');
            });
            this.$('search-mask').on('click', function () {
                $(this).parent().removeClass('active');
            });
            this.$('searchBox').$().on('keyup', 'input', function (e) {
                if (e.which === 13) {
                    var val = $(this).val();
                    var code = encodeURI(val);
                    _hmt.push(['_trackEvent', '搜索', 'click', '关键字', val]);
                    window.location.href = 'products.html?key=' + code;
                }
            });//搜索
            this.$('mobileBtn').on('click', function (inEvent) {
                $('.mobile-menu-dialog').toggleClass('active').children('.dialog-header').collapse('toggle');
            });  //手机按钮 菜单
            this.$('logo').on('click', function (inEvent) {
                window.location = 'index.html'
            });
            this.$('accountMenu').$().on('click', '.exit', function (inEvent) {
                var model = self.getModel();
                // model.set('isLogin', '');
                model.set('exit', new Date());
                inEvent.stopImmediatePropagation();
            });//我的账户 下菜单
        },
        onModelReady: function (inModel) {
            inModel.onChange('isLogin', function (inEvent) {
                var data = inEvent.data;
                if (data === 'logon') {
                    if (this._flag) {
                        this._flag = false;
                    }
                } else {
                    this._flag = true;
                }
            }, this);
        }
    }
});

// self.$('search').removeClass('in');
// self.$('loginMenu').$().fadeOut();
// self.$('wishMenu').$().fadeOut();
// self.$('accountMenu').$().fadeOut();
// self.$('shopCartMenu').$().fadeOut();
//点击logo
// this.$('searchInput').bind('keydown', function (e) {
//     if (e.which == 13) {
//         window.location.href = 'search.html'
//     }
// });
// this.$('searchInput').on('click', function (inEvent) {
//     inEvent.stopImmediatePropagation();
// });
// this.$('login').on('mouseover', function () {
//     self.$('wishMenu').$().fadeOut();
//     self.$('accountMenu').$().fadeOut();
//     self.$('shopCartMenu').$().fadeOut();
//     self.$('loginMenu').$().fadeIn();
// });
// this.$('wish').on('mouseover', function () {
//     if (self._flag) {
//         return
//     }
//     self.$('loginMenu').$().hide();  //fadeOut
//     self.$('accountMenu').$().hide();
//     self.$('shopCartMenu').$().hide();
//     self.$('wishMenu').$().fadeIn();
// }).on('mouseleave',function () {
//     // self.$('loginMenu').$().fadeOut();
//     // self.$('accountMenu').$().fadeOut();
//     // self.$('shopCartMenu').$().fadeOut();
//     self.$('wishMenu').$().fadeOut(5000);
// });
// this.$('account').on('mouseover', function () {
//     self.$('loginMenu').$().hide();   //fadeOut
//     self.$('wishMenu').$().hide();
//     self.$('shopCartMenu').$().hide();
//     self.$('accountMenu').$().fadeIn();
// }).on('mouseleave',function () {
//     // self.$('loginMenu').$().fadeOut();
//     // self.$('shopCartMenu').$().fadeOut();
//     // self.$('shopCartMenu').$().fadeOut();
//     self.$('accountMenu').$().fadeOut(5000);
// });
// this.$('shopCart').on('mouseover', function () {
//     if (self._flag) {
//         return
//     }
//     self.$('loginMenu').$().hide();  //fadeOut
//     self.$('wishMenu').$().hide();
//     self.$('accountMenu').$().hide();
//     self.$('shopCartMenu').$().fadeIn();
// }).on('mouseleave',function () {
//     // self.$('loginMenu').$().fadeOut();
//     // self.$('shopCartMenu').$().fadeOut();
//     // self.$('accountMenu').$().fadeOut();
//     self.$('shopCartMenu').$().fadeOut(5000);
// });
// this.$('searchBox').$().on('click', function (inEvent) {  //搜索
//     var model = self.getModel().get('searchBox');
//     model.set('searchBoxStatus', 'active');
//     inEvent.stopImmediatePropagation();
// });   //搜索


//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/Header.js
// module id = 24
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32